import ApiConfig from '@api';

interface IArrow {
  [key: string]: string;
}

const SIZES: IArrow = {
  background: '?width=1280',
  poster: '?height=298',
  slider: '?width=756',
  photo: '?width=348',
  badge: '?width=100',
  logo: '?height=100',
  hqLogo: '?height=300',
};

const ImageUtils = {
  getImage(image: string | undefined | null, type?: string) {
    if (image && image !== 'undefined' && !image.includes('http')) {
      return ApiConfig.urls.app.baseImgUrl + image + (type ? SIZES[type] : '');
    }
    return image || '';
  },
};

export default ImageUtils;
